module.exports = __webpack_public_path__ + "media/images/countrysquared/bl-4f9ad750aecd09e58c6093ee4dd56a20.svg";